module.exports = __webpack_public_path__ + "static/media/CSharp_example.925d282b.zip";